import { render } from "./create-author.vue?vue&type=template&id=3ace2d6e&ts=true"
import script from "./create-author.vue?vue&type=script&lang=ts"
export * from "./create-author.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__